export default "__VITE_ASSET__Dqao4PND__"